import { render, staticRenderFns } from "./AlertStatistic.vue?vue&type=template&id=382b9154"
import script from "./AlertStatistic.vue?vue&type=script&lang=js"
export * from "./AlertStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports